import React from "react";
import Loader from "../../components/Loader";

export const WalletSyncing: React.FC = () => {
  return (
    <div className="flex flex-1 items-start justify-start px-4">
      <div className="flex w-full flex-col items-center gap-4 rounded-[28px] bg-brand-bg-4 px-7 py-8 text-center">
        <Loader />

        <div className="flex flex-col gap-2">
          <div className="text-2xl font-semibold">
            Syncing your wallet
          </div>
          <div className="text-sm opacity-70">
            Fetching your latest balance and recent transactions.
          </div>
        </div>
      </div>
    </div>
  );
};
